module.exports = __webpack_public_path__ + "static/media/loginlogo.561d5fb0.png";